var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationObserver',{ref:_vm.model.entity},[_c('t-orm-fields-content',_vm._b({attrs:{"ctx":_vm.contentCtx,"items":_vm.model.ormFields,"context":_vm.context}},'t-orm-fields-content',_vm.editedItem,false,true))],1)}
var staticRenderFns = []

export { render, staticRenderFns }